import React from 'react';

export const DatabricksSearchResultIcon = (): React.JSX.Element => {
	return (
		<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="33" height="33" />
			<rect width="2974" height="1094" transform="translate(-561 -608.559)" />
			<path
				d="M0.870117 8.24377C0.870117 3.8255 4.45184 0.243774 8.87012 0.243774H24.8701C29.2884 0.243774 32.8701 3.8255 32.8701 8.24377V24.2438C32.8701 28.6621 29.2884 32.2438 24.8701 32.2438H8.87012C4.45184 32.2438 0.870117 28.6621 0.870117 24.2438V8.24377Z"
				fill="#FF3621"
			/>
			<path
				d="M25.8263 21.1692V17.8557L25.4681 17.6319L16.8711 22.3334L8.72184 17.8557V15.9304L16.8711 20.3632L25.8711 15.4826V12.2139L25.5129 11.9901L16.8711 16.7363L9.03527 12.4378L16.8711 8.13932L23.1845 11.5871L23.6771 11.3184V10.9602L16.8711 7.2438L7.87109 12.1244V12.6169L16.8711 17.5423L25.0203 13.0647V15.0348L16.8711 19.5125L8.2293 14.7662L7.87109 14.9901V18.3035L16.8711 23.1841L25.0203 18.7513V20.6766L16.8711 25.1542L8.2293 20.4528L7.87109 20.6766V21.1692L16.8711 26.0498L25.8263 21.1692Z"
				fill="white"
			/>
		</svg>
	);
};
